import { Eva } from './eva'
import router from '@/router'
import cookies from 'js-cookie'
import Nprogress from 'nprogress'
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

/**
 * create a axios instance
 */
const request = axios.create({
  baseURL: '/api',
  timeout: 1000 * 600
})

// before
request.interceptors.request.use(
  (config: AxiosRequestConfig): AxiosRequestConfig => {
    Nprogress.start()
    config.headers.Authorization = cookies.get('token')
    config.headers.Accept = 'application/vnd.fawn.dashboard+json'
    return config
  },
  (e: AxiosError): void => {
    Promise.reject(e)
  }
)

// after
request.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    Nprogress.done()
    return response
  },
  e => {
    Nprogress.done()
    switch (e.response.status) {
      case 400:
        if (e.request.responseURL.indexOf('auth/login') === -1) {
          (new Eva()).error(e.response.data.message)
        }
        break
      case 422:
        break
      case 401:
        (new Eva()).info('Please log in...')
        router.push({ name: 'auth.login' })
        break
    }

    return Promise.reject(e.response)
  }
)

export default request
